const CSV_ORDER_ROW_HEADERS = [
    'order_number',
    'customer_name',
    'pickup_company',
    'pickup_street',
    'pickup_housenumber',
    'pickup_country',
    'pickup_zip',
    'pickup_city',
    'pickup_from_date',
    'pickup_from_time',
    'pickup_to_date',
    'pickup_to_time',
    'pickup_coordinates',
    'pickup_comment',
    'delivery_company',
    'delivery_street',
    'delivery_housenumber',
    'delivery_country',
    'delivery_zip',
    'delivery_city',
    'delivery_from_date',
    'delivery_from_time',
    'delivery_to_date',
    'delivery_to_time',
    'delivery_coordinates',
    'delivery_comment',
];

type CsvScalarKeys = (typeof CSV_ORDER_ROW_HEADERS)[number];
export type CsvOrderRow = Record<CsvScalarKeys, string>;

export const CSV_BULK_ORDER_ROW_HEADERS = CSV_ORDER_ROW_HEADERS.concat([
    'bulk_quantity',
    'bulk_quantity_unit',
    'bulk_name',
]);
type BulkCsvScalarKeys = (typeof CSV_BULK_ORDER_ROW_HEADERS)[number];
export type BulkCsvOrderRow = Record<BulkCsvScalarKeys, string>;

export const CSV_CARGO_ORDER_ROW_HEADERS = CSV_ORDER_ROW_HEADERS.concat(['cargo_quantity', 'cargo_name']);
type CargoCsvScalarKeys = (typeof CSV_CARGO_ORDER_ROW_HEADERS)[number];
export type CargoCsvOrderRow = Record<CargoCsvScalarKeys, string>;
